import apiClient from "./axiosConfig";
import type { StoredUser } from "types/user";

// Login is password first, then a 6-digit code sent on WhatsApp (routes/credentials.js).

export interface LoginOtpChallenge {
  otpRequired: true;
  channel: "whatsapp";
  userId: string;
  phoneHint: string | null;
  expiresInSeconds: number;
  resendAfterSeconds: number;
  tenantId?: string;
}

export interface AuthenticatedUser extends StoredUser {
  email?: string;
  permissions?: unknown[];
  hasAllAccess?: boolean;
}

export interface LoginSession {
  data: { token: string };
  user: AuthenticatedUser;
}

export interface ResendOtpResponse {
  message: string;
  phoneHint: string | null;
  expiresInSeconds: number;
  resendAfterSeconds: number;
}

export const startLogin = async (payload: {
  userName: string;
  password: string;
}): Promise<LoginOtpChallenge> => {
  const res = await apiClient.post<LoginOtpChallenge>("/api/auth/login", payload);
  return res.data;
};

export const verifyLoginOtp = async (payload: {
  userId: string;
  code: string;
  location?: string;
}): Promise<LoginSession> => {
  const res = await apiClient.post<LoginSession>("/api/auth/verify-otp", payload);
  return res.data;
};

export const resendLoginOtp = async (userId: string): Promise<ResendOtpResponse> => {
  const res = await apiClient.post<ResendOtpResponse>("/api/auth/resend-otp", { userId });
  return res.data;
};

export const sendPasswordResetOtp = async (userName: string): Promise<{ message: string }> => {
  const res = await apiClient.post<{ message: string }>("/api/auth/reset-password/send-otp", {
    userName,
  });
  return res.data;
};

export const resetPassword = async (payload: {
  userName: string;
  newPassword: string;
  otp: string;
}): Promise<{ message: string }> => {
  const res = await apiClient.post<{ message: string }>("/api/auth/reset-password", payload);
  return res.data;
};
